import React from "react";
import { Link } from "react-router-dom";
import "../../App.css";

const Error = () => {
  
  return (
    <div className="home-container-1">
      <div className="home-container-2">
        <p className="wrongurl">
          SORRY, This is a wrong URL.
        </p>
      </div>
      <Link to="/register">
        <button id="my-chat-btn">Chat</button>
      </Link>
    </div>
  );
};

export default Error;